export default "__VITE_ASSET__98ea8490__"